import React, { useState, useEffect } from "react";

import styled from "styled-components";
import moment from "moment";
import { language, translate } from "../../../../../_helpers/general.helper";
import { applyNowIcon } from "./styles";

const UnitDetailsContainer = styled.div`
  background: #fff;
  height: 160px;
  margin: 0 10px 0px 10px;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  padding-top: 20px;

  &.studentList {
    height: initial;
    border-bottom: 1px solid #ededed;
    padding-bottom: 8px;
    padding-top: 8px;
  }

  &.expanded {
    min-height: 120px;
    height: fit-content;
    transition: height 0.3s linear;
  }

  .info-container {
    display: flex;
    justify-content: space-between;
    height: 70px;
    padding: 0 15px;
    padding-top: 0px;
    width: 100%;
    margin-bottom: 14px;

    .leftInfo {
      display: flex;
      flex-direction: column;
      align-items: start;
      margin-top: 10px;
      width: 60%;
      overflow: hidden;
    }

    .info-date {
      color: var(--Secondary-Gray2, #6c757d);
      font-family: "DM Sans";
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 5px;
    }

    .unit-name {
      color: var(--Primary-DarkBlue, #0f0538);
      font-family: "DM Sans";
      font-size: 20px;
      font-weight: 700;
      text-transform: capitalize;
      margin-bottom: 5px;
      text-align: start;
    }

    .floor {
      color: var(--Secondary-Gray2, #6c757d);
      font-family: "DM Sans";
      font-size: 12px;
      font-weight: 500;
      margin-left: 10px;
    }

    .unit-price {
      color: #0f0538;
      font-family: "DM Sans";
      font-size: 20px;
      font-weight: 700;
      .month {
        color: #414b64;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 5px;
      }
    }
  }

  .unit-map {
    display: flex;
    justify-content: space-between;
    color: #6c757d;
    font-family: "DM Sans";
    font-size: 15px;
    font-weight: 500;
    width: 100%;
    margin-bottom: 25px;
    /* padding: 0 15px; */
    img {
      margin-right: 5px;
    }

    svg {
      margin-left: 5px;
      margin-bottom: 5px;
    }

    .unit-map-button {
      padding: 6px 12px;
      border: 1px solid #42accd;
      border-radius: 4px;
      background: #ecf7fa;
      font-size: 14px;
      cursor: ponter;

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        font-size: 16px;
      }
      &:hover {
        background-color: #d3f3fc;
      }
    }

    .unit-price {
      color: #0f0538;
      font-family: "DM Sans";
      font-size: 20px;
      font-weight: 700;
      .month {
        color: #414b64;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 5px;
      }
    }

    .apply-now {
      font-size: 14px;
      padding: 6px 12px;
      border: 1px solid #42accd;
      border-radius: 4px;
      background: #ecf7fa;
      color: inherit;
      text-decoration: none;
      display: flex;
      align-items: center;

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        font-size: 16px;
      }

      &:hover {
        background-color: #d3f3fc;
      }
    }
  }

  .showMore {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    height: 38px;
    background: #f1f4f6;
    color: #39abcf;
    font-family: "DM Sans";
    font-size: 14px;
    text-transform: capitalize;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;

    border-radius: 0 0 8px 8px;

    &:hover {
      background-color: #ecf7fa;
    }

    .more-info {
      a {
        color: #49536c;
        font-family: "DM Sans";
        font-size: 14px;
        text-transform: capitalize;
        text-decoration: none;
      }
    }

    div {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .show-more-btn {
      cursor: pointer;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      height: 42px;
      font-size: 16px;
    }
  }

  .rightInfo {
    text-align: end;
    margin-top: 10px;

    .special-icon {
      height: 20px;
      margin-right: 8px;
    }

    .likeHeart {
      cursor: pointer;
      margin-bottom: 2px;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    margin: 0 35px 0px 35px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 80%;
    margin-left: auto;
    margin-right: auto;

    .info-container {
      height: 85px;
      .info-date {
        font-size: 18px;
        font-weight: 500;
      }

      .floor {
        font-size: 16px;
      }

      .unit-name {
        font-size: 24px;
      }

      .unit-price {
        font-size: 24px;
      }

      .unit-map {
        font-size: 16px;
      }

      .likeHeart {
        width: 20px;
      }
    }

    .show-more-btn {
      font-size: 18px;
    }
  }

  /* table view */

  .info-container-table {
    height: 100%;
  }

  .rows-wrapper {
    height: calc(100% - 50px);
    overflow-y: auto;
  }

  .rows-wrapper::-webkit-scrollbar {
    width: 6px;
  }

  .rows-wrapper::-webkit-scrollbar-track {
    border-radius: 24px;
    background-color: #f7f9fa;
  }

  .rows-wrapper::-webkit-scrollbar-thumb {
    border-radius: 24px;
    background-color: #d9d9d9;
  }
  .unit-header,
  .unit-row {
    display: grid;
    grid-template-columns: 0px 1fr 1fr 1fr 1fr 1fr 250px;
    border-bottom: 1px solid #ededed;
    padding: 12px 12px;
    margin-right: 30px;

    .special-row-icon {
        height: 16px;
    }

    &.special-icon { 
    grid-template-columns: 30px 1fr 1fr 1fr 1fr 1fr 250px;
    }

    &.student-row,
    &.student-header {
      grid-template-columns: 1fr 1fr 1fr 250px;
    }

    &.hide-price {
      grid-template-columns: 1fr 1fr 1fr 1fr 250px;

      &.special-icon {
        grid-template-columns: 30px 1fr 1fr 1fr 1fr 250px;
      }
      &.student-row,
      &.student-header {
        grid-template-columns: 1fr 1fr 250px;
      }
    }

    div {
      display: flex;
      align-items: center;
      color: var(--Primary-DarkBlue, #0f0538);
      font-size: 14px;
      font-weight: 500;
      font-style: "DM Sans";
      text-transform: capitalize;
    }
  }

  .unit-header {
    margin-right: 36px;
    border-bottom: 2px solid #ededed;
  }

  .unit-row {
    div {
      color: var(--Primary-Dark-Blue, var(--Primary-DarkBlue, #0f0538));
      font-family: "DM Sans";
      font-size: 16px;

      &.bold-element {
        font-weight: 800;

        .extension {
          font-weight: 400;
          font-size: 14px;
          text-transform: lowercase;
          margin-left: 4px;
        }
      }
    }
  }

  &.table-container {
    height: 60%;
    padding-top: 0;

    .more-details-button {
      height: 34px;
      padding: 6px 12px;
      border: none;
      background-color: transparent;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.4px;
      color: #42accd;
      border-radius: 4px;

      &:hover {
        background-color: rgba(66, 172, 205, 0.1);
      }
    }

    .apply-now-button {
      height: 34px;
      padding: 6px 12px;
      border: none;
      background-color: transparent;
      font-size: 14px;
      font-weight: 500;
      color: rgba(15, 5, 56, 0.76);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      text-decoration: none;

      &:hover {
        background-color: rgba(66, 172, 205, 0.1);
      }
    }

    .likeHeart {
      height: 20px;
      cursor: pointer;
    }

    .buttons-wrapper {
      display: flex;
      justify-content: end;
      gap: 10px;
    }
  }

  .apply-now-btn {
    display: inline-flex;
    height: 34px;
    padding: 6px 12px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border-radius: 4px;
    border: 1px solid var(--Primary-Blue, #42accd);
    background: #ecf7fa;
    text-decoration: none;
    cursor: pointer;
    color: #464269;
    font-family: "DM Sans";
    font-size: 14px;
    font-weight: 500;
  }

  .student-container {
    align-items: center;
    .unit-map {
      margin-bottom: 5px;
    }

    .unit-name {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .unit-deposit {
      font-size: 13px;
    }
  }

  .special-banner {
    margin: 0 25px;
    border-radius: 4px;
    background: #f6fdff;
    width: 100%;
    padding: 8px;
  }
`;

const SpecialBanner = styled.div`
  margin: 10px;
  border-radius: 4px;
  background: #f6fdff;
  padding: 8px;
  text-align: start;
  color: #0f0538;
  font-family: "DM Sans";
  font-size: 13px;
  img {
    margin-right: 15px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    margin: 0 25px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;

    img {
      height: 16px;
    }
  }
`;

function UnitDetails({
  info,
  likeUnit,
  floorplan,
  showPrice,
  tid,
  setExpandedUnit,
  likedUnits,
  list,
  dataUnits,
  lang,
}) {
  // const [isLiked, setIsLiked] = useState(false);
  let amenities = "";

  const isStudent = floorplan.bot_type === "Student";

  const isLiked = (el) => {
    return likedUnits.find(
      (unit) => unit.unit === el.id && unit.floorplan === floorplan.floorplan_id
    );
  };

  const hasUnitSpecial = () => {
    return floorplan.units && floorplan.units.some((unit) => !!unit.specials);
  };

  const hasElementActiveSpecial = (unit) => {
    let dateNow = new Date();
    if (unit.specials && !unit.special_start_date) {
      return true;
    } else if (
      unit.specials &&
      new Date(unit.special_start_date) < dateNow &&
      new Date(unit.special_end_date) > dateNow
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {floorplan.specials && (
        <SpecialBanner>
          {" "}
          <img src="/images/light-mode/specials.svg"></img>
          {translate("Special offer available on all units", language(tid))}
        </SpecialBanner>
      )}
      {!floorplan.specials && hasUnitSpecial(floorplan, lang) && (
        <SpecialBanner>
          {" "}
          <img src="/images/light-mode/specials.svg"></img>
          {translate("Special offer available on select units", language(tid))}
        </SpecialBanner>
      )}
      {list &&
        dataUnits.map((el, i) => {
          if (el.amenities) {
            amenities = (
              <ul>
                {el.amenities.split("\n").map((el, i) => {
                  return <li key={i}>{el}</li>;
                })}
              </ul>
            );
          }

          if (!isStudent) {
            return (
              <UnitDetailsContainer>
                <div className="info-container">
                  <div className="leftInfo">
                    <div className="info-date">
                      {translate("Available:", language(tid))}{" "}
                      {moment(el.availability_date).format("MM/DD/YYYY")}
                    </div>
                    <div className="unit-name">
                      APT {el.unit_number}
                      <span className="floor">
                        {el.square_feet}{" "}
                        {el.square_feet != null ? "sq. ft" : ""}
                      </span>
                    </div>
                  </div>
                  <div className="rightInfo">
                    {hasElementActiveSpecial(el) && (
                      <img
                        class="special-icon"
                        src="/images/light-mode/specials.svg"
                      ></img>
                    )}
                    {isLiked(el) ? (
                      <img
                        className="likeHeart"
                        src={"/images/Heart-fill.svg"}
                        alt="like"
                        onClick={() => {
                          likeUnit(el);
                        }}
                      />
                    ) : (
                      <img
                        className="likeHeart"
                        src={"/images/Heart-empty.svg"}
                        alt="like"
                        onClick={() => {
                          likeUnit(el);
                        }}
                      />
                    )}
                    <div className="unit-map">
                      {showPrice && (
                        <span className="unit-price">
                          $ {el.rent_rate.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          <span className="month">/mo</span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="showMore" onClick={() => setExpandedUnit(el)}>
                  <div className="show-more-btn">
                    <div> {translate("View Unit", language(tid))}</div>
                  </div>
                </div>
              </UnitDetailsContainer>
            );
          } else {
            return (
              <UnitDetailsContainer className="studentList">
                <div className="info-container student-container">
                  <div className="leftInfo">               
                    <div className="unit-name">
                      {el.unit_number}
                      <span className="floor">
                        {/* {el.square_feet} {el.square_feet != null ? "sq. ft" : "" } */}
                      </span>
                    </div>
                    <div className="unit-deposit">
                      {translate("Deposit", language(tid))}:{" "}
                      {el.deposit || "N/A"}
                    </div>
                  </div>
                  <div className="rightInfo">
                    <div className="unit-map">
                      {showPrice && (
                        <span className="unit-price">
                          $ {el.rent_rate.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          <span className="month">/mo</span>
                        </span>
                      )}
                    </div>
                    <div>
                      <a
                        className="apply-now-btn"
                        href={el.apply_now}
                        target="blank"
                      >
                        {translate("Apply Now", language(tid))}
                        {applyNowIcon}
                      </a>
                    </div>
                  </div>
                </div>
              </UnitDetailsContainer>
            );
          }
        })}

      {!list && isStudent && (
        <UnitDetailsContainer className="table-container ">
          <div className="info-container-table">
            <div
              className={`unit-header ${
                !showPrice && "hide-price"
              } student-header`}
            >
              <div>{translate("Option", language(tid))}</div>
              <div>{translate("Deposit", language(tid))}</div>

              {/* <div>Size</div> */}
              {showPrice && <div>{translate("Price", language(tid))}</div>}
              {/* <div>Interest</div>
              <div>Sq. Ft</div> */}
              {/* <div></div> */}
              <div></div>
            </div>

            <div className="rows-wrapper">
              {dataUnits.map((el, i) => {
                return (
                  <div
                    className={`unit-row ${
                      !showPrice && "hide-price"
                    } student-row`}
                  >
                    <div className="bold-element">{el.unit_number}</div>
                    <div>{el.deposit || "N/A"}</div>
                    {showPrice && (
                      <div className="bold-element">
                        $ {el.rent_rate.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                        <span className="extension"> /mo</span>
                      </div>
                    )}

                    <div className="buttons-wrapper">
                      {el.apply_now && (
                        <a
                          className="apply-now-btn"
                          target="blank"
                          href={el.apply_now}
                        >
                          {translate("Apply Now", language(tid))} {applyNowIcon}
                        </a>
                      )}
                      {/* <button
                        className="more-details-button"
                        onClick={() => setExpandedUnit(el)}
                      >
                        More Details
                      </button> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </UnitDetailsContainer>
      )}

      {!list && !isStudent && (
        <UnitDetailsContainer className="table-container">
          <div className="info-container-table">
            <div className={`unit-header ${!showPrice && "hide-price"} ${hasUnitSpecial() && "special-icon"}`}>
              <div></div>
              <div>Unit</div>
              <div>Availability</div>

              {/* <div>Size</div> */}
              {showPrice && <div>Price</div>}
              <div>Interest</div>
              <div>Sq. Ft</div>
              <div></div>
              <div></div>
            </div>

            <div className="rows-wrapper">
              {dataUnits.map((el, i) => {
                return (
                  <div className={`unit-row ${!showPrice && "hide-price"} ${hasUnitSpecial() && "special-icon"}`}>
                    {hasElementActiveSpecial(el) ? <div><img class="special-row-icon" src="/images/light-mode/specials.svg"></img></div> : <div></div> }
                    <div className="bold-element">APT {el.unit_number}</div>
                    <div>{moment(el.availability_date).format("MM/DD/YY")}</div>
                    {/* <div>Size</div> */}
                    {showPrice && (
                      <div className="bold-element">
                        $ {el.rent_rate.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                        <span className="extension"> /mo</span>
                      </div>
                    )}
                    <div>
                      {" "}
                      {isLiked(el) ? (
                        <img
                          className="likeHeart"
                          src={"/images/Heart-fill.svg"}
                          alt="like"
                          onClick={() => {
                            // setIsLiked(!isLiked);
                            likeUnit(el);
                          }}
                        />
                      ) : (
                        <img
                          className="likeHeart"
                          src={"/images/Heart-empty.svg"}
                          alt="like"
                          onClick={() => {
                            // setIsLiked(!isLiked);
                            likeUnit(el);
                          }}
                        />
                      )}
                    </div>
                    <div>
                      {el.square_feet}{" "}
                      {el.square_feet != null ? "sq. ft" : "N/A"}
                    </div>
                    <div className="buttons-wrapper">
                      {el.apply_now && (
                        <a
                          className="apply-now-button"
                          target="blank"
                          href={el.apply_now}
                        >
                          {translate("Apply Now", language(tid))} {applyNowIcon}
                        </a>
                      )}
                      <button
                        className="more-details-button"
                        onClick={() => setExpandedUnit(el)}
                      >
                        More Details
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </UnitDetailsContainer>
      )}
      {/* {!list && dataUnits.} */}
    </>
  );
}

export default UnitDetails;
